import { publicHttpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '@/api/api-routes';
export type PackageSizeDefinitionsResponse = {
  size: string;
  description: string;
  image_url: string;
  max_weight: number;
  min_weight?: number;
  package_in_centimeters?: {
    length: number;
    width: number;
    height: number;
  };
};

export const getPackageSizeDefinitionsFn = async (deliveryType: string) => {
  const endpoint = deliveryType
    ? `${apiRoutes.packageSizeDefinitions}?delivery_type=${deliveryType}`
    : apiRoutes.packageSizeDefinitions;

  const response =
    await publicHttpClient.get<PackageSizeDefinitionsResponse[]>(endpoint);
  return response.data;
};
